/* eslint-disable react/jsx-no-bind */

'use client';

import { useEffect, useState } from 'react';
import { useFormState } from 'react-dom';
import Button from '@referralexchange/rea-ui-react/src/atoms/Button';
import Input from '@referralexchange/rea-ui-react/src/atoms/Input';
import Container from '@referralexchange/rea-ui-react/src/components/blocks/Container';
import Grid from '@referralexchange/rea-ui-react/src/components/containers/Grid';
import Textarea from '@referralexchange/rea-ui-react/src/atoms/Textarea';
import { useAnalytics } from '~/contexts/AnalyticsContext.tsx';
import Failed from './Failed';
import Success from './Success';

import { createContact } from './actions';

const initialState = {
  alert: '',
  rateLimited: false,
  errors: {},
  formData: {},
};

export default function ContactUsForm() {
  const analytics = useAnalytics();
  const [state, formAction] = useFormState(createContact, initialState);
  const [values, setValues] = useState({
    full_name: '',
    email: '',
    message: '',
  });
  const [errors, setErrors] = useState(state.errors);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (state.alert === 'success' || state.alert === 'error') {
      setShowModal(true);
    }
    if (state.alert === 'success') {
      analytics.reaa('contact_us_success');
      setValues({
        full_name: '',
        email: '',
        message: '',
      });
      setErrors({});
    } else if (state.alert === 'error') {
      analytics.reaa('contact_us_error');
      setErrors(state.errors);
    }
    setLoading(false);
  }, [state]);

  function handleSubmit(e) {
    const newErrors = {};

    if (!values.full_name || values.full_name.trim().length < 3) {
      newErrors.full_name = 'Please enter a valid name.';
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!values.email || !emailRegex.test(values.email)) {
      newErrors.email = 'Please enter a valid email address.';
    }

    if (!values.message || values.message.trim().length < 10) {
      newErrors.message = 'Message must be at least 10 characters long.';
    }

    if (Object.keys(newErrors).length > 0) {
      e.preventDefault();
      setErrors(newErrors);
      return;
    }
    analytics.reaa('contact_us_submit');
    setLoading(true);
  }

  function handleChange(e) {
    const { name, value } = e.target;

    setValues((v) => ({
      ...v,
      [name]: value,
    }));
  }

  function handleCloseModal() {
    setShowModal(false);
  }

  return (
    <Container>
      <form action={formAction} onSubmit={handleSubmit}>
        {showModal && state.alert === 'success' && (
          <Success isOpen={showModal} onClose={handleCloseModal} />
        )}
        {showModal && state.alert === 'error' && (
          <Failed isOpen={showModal} onClose={handleCloseModal} rateLimited={state.rateLimited} />
        )}
        <Grid twoColumn={false}>
          <Input
            name="full_name"
            label="Full Name"
            type="text"
            autoComplete="name"
            value={values.full_name || ''}
            onChange={handleChange}
            invalid={!!errors.full_name}
            required
            minLength={3}
          />
          <Input
            name="email"
            type="email"
            label="Email Address"
            value={values.email || ''}
            onChange={handleChange}
            invalid={!!errors.email}
            required
          />
          <Textarea
            name="message"
            label="Message"
            value={values.message || ''}
            onChange={handleChange}
            className="textarea"
            required
            minLength={10}
          />
          <Button loading={loading} disabled={loading} type="submit">
            Contact Me
          </Button>
        </Grid>
      </form>
    </Container>
  );
}
